// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kabuto: PokeData = {
  "id": 140,
  "name": "kabuto",
  "height": 5,
  "weight": 115,
  "base_experience": 71,
  "types": [
    PokeType.ROCK,
    PokeType.WATER
  ],
  "api_moves": [
    "scratch",
    "sand-attack",
    "leer",
    "hydro-pump",
    "absorb",
    "mega-drain",
    "rock-throw",
    "harden",
    "leech-life",
    "rock-slide",
    "slash",
    "protect",
    "endure",
    "ancient-power",
    "metal-sound",
    "mud-shot",
    "brine",
    "wring-out",
    "stone-edge",
    "aqua-jet",
    "liquidation"
  ],
  "moves": [
    "scratch",
    "leer",
    "hydro-pump",
    "rock-throw",
    "rock-slide",
    "protect",
    "ancient-power",
    "metal-sound",
    "mud-shot",
    "brine",
    "aqua-jet",
    "liquidation",
    "rock-blast"
  ],
  "evolution_chain": {
    "id": 70,
    "item": null,
    "species": [
      {
        "name": "kabuto",
        "order": 171,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kabutops",
        "order": 172,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": 140,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 48.75,
    "speed": 55,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
